var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBenefit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 10.9L11.4 1l9.899 9.9-9.9 9.899-9.899-9.9zm9.9-7.072L4.327 10.9l7.071 7.07 7.072-7.07-7.072-7.072zM3.62 10.192l-.707.707.707.708 7.071 7.07.707.708.708-.707 7.07-7.071.708-.707-.707-.708-7.071-7.07-.707-.708-.708.707-7.07 7.071zm8.485 1.415a1 1 0 10-1.415-1.415 1 1 0 001.415 1.415zm-4.242-1.415a1 1 0 11-1.415 1.415 1 1 0 011.415-1.415zm4.242 5.657a1 1 0 10-1.415-1.414 1 1 0 001.415 1.414zm0-9.9a1 1 0 11-1.415 1.415 1 1 0 011.415-1.414zm4.242 5.658a1 1 0 10-1.414-1.415 1 1 0 001.414 1.415zM17.5 17h14v14h-14V17zm12 2h-10v10h10V19zm-10-1h-1v12h12V18h-11zm5 7a1 1 0 100-2 1 1 0 000 2z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
}

export default SvgBenefit2;